import React, { useState, useRef } from 'react';
import './DouyinCallback.scss';
import { Button } from '@material-ui/core';
export default function DouyinCallback() {
  const [liveData, setLiveData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [channelId, setChannelId] = useState('');
  const intervalRef = useRef(null);
  const fetchData1 = () => {
    setLiveData(null)
    setLoading(true);
    setError(null);
    fetch(`/api/v1/youtube/video-realtime?videoId=${encodeURIComponent(channelId)}`)
      .then(res => {
        if (!res.ok) throw new Error('网络请求失败');
        return res.json();
      })
      .then(data => {
        setLiveData(data.data);
        setLoading(false);
        setShow(true);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
        setShow(true);
      });
  };

  const fetchData2 = () => {
    setLiveData(null)
    setLoading(true);
    setError(null);
    fetch(`/api/v1/youtube/video-analytics?videoId=${encodeURIComponent(channelId)}`)
      .then(res => {
        return res.json();
      })
      .then(data => {
        setLiveData(data.data);
        setLoading(false);
        setShow(true);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
        setShow(true);
      });
  };


  const fetchData3 = () => {
    setLiveData(null)
    setLoading(true);
    setError(null);
    fetch(`/api/v1/auth/youtube/disconnect`)
      .then(res => {
        return res.json();
      })
      .then(data => {
        setLiveData(data.data);
        setLoading(false);
        setShow(true);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
        setShow(true);
      });
  };

  const fetchData4 = () => {
    setLiveData(null)
    setLoading(true);
    setError(null);
    fetch(`/api/v1/youtube/channel?channelName=${encodeURIComponent(channelId)}`)
      .then(res => {
        return res.json();
      })
      .then(data => {
        setLiveData(data.data);
        setLoading(false);
        setShow(true);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
        setShow(true);
      });
  };

  const fetchData5 = () => {
    setLiveData(null)
    setLoading(true);
    setError(null);
    fetch('/api/v1/admin/quest/execute-secondary-processor', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        // 这里可以根据需要添加请求参数
        questId: channelId, // 使用当前输入框的值作为questId，或者可以根据实际需求调整
      }),
    })
      .then(res => {
        return res.json();
      })
      .then(data => {
        setLiveData(data);
        setLoading(false);
        setShow(true);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
        setShow(true);
      });
  };
  // 组件卸载时清除定时器
  React.useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <div className='douyin-page'>
      <h3 style={{ textAlign: "center" }}>你的YouTube频道数据</h3>
      <label>
        输入参数（ChannelId/VideoId）：
        <input
          type="text"
          value={channelId}
          onChange={e => setChannelId(e.target.value)}
          placeholder="请输入ChannelId或VideoId"
          style={{ marginLeft: 8 }}
        />
      </label>
      <div>
        <Button variant="contained" onClick={fetchData1} style={{ marginLeft: 12 }}>点击查看视频实时数据</Button>
        <Button variant="contained" onClick={fetchData2} style={{ marginLeft: 12 }}>点击查看视频报告</Button>
        <Button variant="contained" onClick={fetchData4} style={{ marginLeft: 12 }}>点击查看频道信息</Button>
        <Button variant="contained" color="primary" onClick={fetchData5} style={{ marginLeft: 12 }}>执行Secondary Processor</Button>
        <Button variant="contained" color="secondary" onClick={fetchData3} style={{ marginLeft: 12 }}>解除youtube授权</Button>
      </div>


      {show && (
        <>
          {loading && <div>正在加载数据...</div>}
          {error && <div style={{ color: 'red' }}>{error.message}</div>}
          {!loading && !error && !liveData && <div>暂无数据</div>}
          {liveData && (
            <div style={{ marginTop: 16, border: '1px solid #eee', borderRadius: 6, padding: 16, maxWidth: 1200 }}>
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                {JSON.stringify(liveData, null, 2)}
              </pre>
            </div>
          )}
        </>
      )}
    </div>
  );
}
